module.exports = __webpack_public_path__ + "media/images/Metal-Bar-Scratched-2-1920px-1e264838a8bc929186ed9da1ee8793ce.png";